<template>
  <PageBreadcrumbs :items="breadcrumbs" />
  <ProductCompletion :product="product" />
  <ContentCard>
    <template #header>
      <ReviewsProductTabs />
    </template>
    <template #subheader>
      <RouterView :product="product" name="subheader" />
    </template>
    <RouterView :product="product" />
  </ContentCard>
</template>
<script setup lang="ts">
import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import { ProductCompletion } from '@/components/ProfileCompletion'
import { useReviewsProductBreadcrumbs } from '@/composables/breadcrumbs/useReviewsProductBreadcrumbs'
import type { ProductData } from '@/gql/reviews'
import ContentCard from '@/ui/ContentCard.vue'

import ReviewsProductTabs from './ReviewsProductTabs.vue'

const props = defineProps<{
  product: ProductData
}>()

const breadcrumbs = useReviewsProductBreadcrumbs(props.product)
</script>
